module.exports = __webpack_public_path__ + "static/JuliaVila-c89bf686a714d39a338730a8d2dbd8ff.png";